export const foldersEndpoint = `/api/v1/folders`
export const folderItemsEndpoint = `/api/v1/folder_items`
